// @avantia common-code
import { Policy } from '../types/policyTypes';
import * as buildings from './buildings';
import * as buildingsAdFull from './buildingsAdFull';
import * as buildingsAndContents from './buildingsAndContents';
import * as contents from './contents';
import * as evan from './evan';
import * as expired from './expired';
import * as extendedPerils from './extendedPerils';
import * as florence from './florence';
import * as floodRe from './floodRe';
import * as hasClaims from './hasClaims';
import * as hasContentsAdBasic from './hasContentsAdBasic';
import * as jointPolicyHolders from './jointPolicyHolders';
import * as personalPossessions from './personalPossessions';
import * as specifiedItems from './specifiedItems';
import * as unoccupied from './unoccupied';

export type MockPolicyKey =
  | 'buildings'
  | 'buildingsAdFull'
  | 'contents'
  | 'hasContentsAdBasic'
  | 'buildingsAndContents'
  | 'specifiedItems'
  | 'personalPossessions'
  | 'unoccupied'
  | 'extendedPerils'
  | 'hasClaims'
  | 'floodRe'
  | 'expired'
  | 'florence'
  | 'evan'
  | 'jointPolicyHolders';

const registry: Record<MockPolicyKey, { policy: Policy; label: string }> = {
  buildings,
  buildingsAdFull,
  contents,
  hasContentsAdBasic,
  buildingsAndContents,
  specifiedItems,
  personalPossessions,
  unoccupied,
  extendedPerils,
  hasClaims,
  floodRe,
  expired,
  florence,
  evan,
  jointPolicyHolders
};

export const namedPolicies: Record<MockPolicyKey, Policy> = Object.fromEntries(
  (Object.entries(registry) as [MockPolicyKey, { policy: Policy; label: string }][]).map(([key, val]) => [
    key,
    val.policy
  ])
) as Record<MockPolicyKey, Policy>;

export const mockPolicyLabels: Record<MockPolicyKey, string> = Object.fromEntries(
  (Object.entries(registry) as [MockPolicyKey, { policy: Policy; label: string }][]).map(([key, val]) => [
    key,
    val.label
  ])
) as Record<MockPolicyKey, string>;

export const singlePolicyModeLabel = 'Single Policy';
export const multiplePoliciesModeLabel = 'Multiple Policies';
export const allPoliciesLabel = 'All';
